/* ==================================================================
   SOU NEUF — MOTEUR CADEAU 30 € — v1
   Porte-savon aimanté offert dès 30 € d'achat, jusqu'au 23 août.

   CE QUE CE FICHIER FAIT
   - Ajoute le porte-savon au panier dès que le sous-total éligible atteint 30 €
   - Le retire dès que le panier repasse en dessous, ou après la date de fin
   - Le pose sur une ligne distincte (propriété de ligne) pour qu'un porte-savon
     acheté volontairement ne fusionne pas avec le cadeau
   - Affiche la jauge en distance restante
   - Vérifie une dernière fois au clic sur "Passer commande"

   CE QUE CE FICHIER NE FAIT PAS
   Il ne met aucun prix à zéro. Le passage à 0,00 € est fait côté serveur par la
   remise automatique Shopify "Achetez X, obtenez Y" (30 € minimum → 1 × variant
   53593342116184 à 100 %, une par commande, fin le 23/08). Sans cette remise
   active, ce script ajoute un article à 8 € et le client le paie.
   La remise se crée EN PREMIER. Ce script vient après.

   OÙ LE POSER
   theme.liquid, dans le <head>, juste avant </head>. Sans defer.
   Le script remplace window.fetch pour détecter les modifications du panier :
   il doit tourner avant les scripts du thème, sinon un thème qui a capturé une
   référence à fetch au chargement passe à travers. Il gère lui-même le fait que
   le DOM ne soit pas encore prêt.

   LA JAUGE (facultative — le moteur tourne sans)
   Coller <div data-sn-cadeau></div> là où elle doit apparaître.
   Page panier : bloc Liquid personnalisé dans l'éditeur de thème, sans toucher au code.
   Tiroir panier : édition du snippet correspondant.
   ================================================================== */

(function () {
  'use strict';

  /* ======================= CONFIGURATION =======================
     >>> SEULE PARTIE À MODIFIER <<< */

  var VARIANT_CADEAU = 53593342116184;      // porte-savon aimanté (le payant, pas le doublon)
  var SEUIL_EUROS    = 30;
  var FIN            = '2026-08-23T23:59:59';

  // Propriété de ligne : c'est elle qui empêche la fusion avec un porte-savon acheté.
  var PROP_CLE = 'Cadeau';
  var PROP_VAL = 'Offert jusqu\u2019au 23 ao\u00fbt';

  // COPY — À VALIDER AVANT MISE EN LIGNE. Voix d'Hélène, tutoiement, jamais "gratuit".
  var COPY = {
    enRoute: function (reste) {
      return 'Encore ' + reste + ' et je te glisse le porte-savon aimant\u00e9 dans ton colis.';
    },
    atteint: 'Ton porte-savon aimant\u00e9 est dans ton panier. Il part avec tes savons.'
  };

  // Sections du thème à re-rendre après une modification du panier.
  // Vide = repli (rechargement sur /cart, simple mise à jour de la pastille ailleurs).
  // Dawn et dérivés : ['cart-drawer','cart-icon-bubble','main-cart-items','main-cart-footer']
  var SECTIONS = [];

  var CIBLE = '[data-sn-cadeau]';

  /* ============================================================== */

  var SEUIL = SEUIL_EUROS * 100;            // tout est en centimes
  var finTs = new Date(FIN).getTime();

  var occupe = false;                       // mutex : une seule opération à la fois
  var interne = false;                      // marque nos propres appels panier
  var ajoutImpossible = false;              // rupture de stock : on n'insiste pas
  var minuteur = null;
  var dernierEtat = null;

  /* ---------------------------------------------------------------
     Utilitaires
     --------------------------------------------------------------- */

  function eur(cents) {
    var n = cents / 100;
    var s = (n % 1 === 0) ? String(n) : n.toFixed(2).replace('.', ',');
    return s + '\u00a0\u20ac';
  }

  function offreActive() {
    return Date.now() < finTs;
  }

  function json(url, options) {
    interne = true;
    var o = options || {};
    o.headers = o.headers || {};
    o.headers['Accept'] = 'application/json';
    return fetch(url, o)
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw e; }); }
        return r.json();
      })
      .then(function (d) { interne = false; return d; })
      .catch(function (e) { interne = false; throw e; });
  }

  /* ---------------------------------------------------------------
     Lecture du panier
     --------------------------------------------------------------- */

  // La ligne cadeau, c'est le bon variant ET la propriété. Un porte-savon acheté
  // porte le même variant mais aucune propriété : on ne doit jamais le supprimer.
  function estLigneCadeau(item) {
    return item.variant_id === VARIANT_CADEAU &&
           item.properties &&
           item.properties[PROP_CLE];
  }

  // Sous-total éligible = tout le panier SAUF la ligne cadeau elle-même.
  // Sans cette exclusion, le cadeau à 8 € gonfle le total et s'auto-entretient :
  // un panier à 25 € qui aurait reçu le cadeau par erreur afficherait 33 € et
  // ne redescendrait jamais.
  // On somme original_line_price (avant remise), ce qui est la base sur laquelle
  // Shopify évalue le montant minimum. À confirmer sur un panier réel.
  function sousTotalEligible(cart) {
    return (cart.items || []).reduce(function (somme, item) {
      return estLigneCadeau(item) ? somme : somme + item.original_line_price;
    }, 0);
  }

  function trouverCadeau(cart) {
    var lignes = cart.items || [];
    for (var i = 0; i < lignes.length; i++) {
      if (estLigneCadeau(lignes[i])) { return lignes[i]; }
    }
    return null;
  }

  /* ---------------------------------------------------------------
     Mutations
     --------------------------------------------------------------- */

  function ajouterCadeau() {
    var props = {};
    props[PROP_CLE] = PROP_VAL;
    return json('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT_CADEAU, quantity: 1, properties: props }] })
    });
  }

  // On passe par la clé de ligne (item.key), pas par l'index : la clé reste juste
  // même si le panier a bougé entre la lecture et l'écriture.
  function reglerCadeau(cle, quantite) {
    return json('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite })
    });
  }

  /* ---------------------------------------------------------------
     Le cycle : lire, décider, agir, afficher
     --------------------------------------------------------------- */

  function cycle() {
    if (occupe) { return Promise.resolve(); }
    occupe = true;

    return json('/cart.js')
      .then(function (cart) {
        var eligible = sousTotalEligible(cart);
        var cadeau = trouverCadeau(cart);
        var meritee = offreActive() && eligible >= SEUIL;

        // Le panier est repassé sous le seuil : on autorise une nouvelle tentative
        // si la précédente avait échoué (rupture temporaire, par exemple).
        if (!meritee) { ajoutImpossible = false; }

        if (meritee && !cadeau && !ajoutImpossible) {
          return ajouterCadeau()
            .then(function () { return rafraichir(); })
            .catch(function () { ajoutImpossible = true; });
        }

        if (!meritee && cadeau) {
          return reglerCadeau(cadeau.key, 0).then(function () { return rafraichir(); });
        }

        // Défensif : le cadeau est offert à l'unité. Si une manipulation panier a
        // fait passer la ligne à 2, la remise n'en couvre qu'une et le client paie
        // la seconde sans l'avoir voulu.
        if (cadeau && cadeau.quantity > 1) {
          return reglerCadeau(cadeau.key, 1).then(function () { return rafraichir(); });
        }

        peindre(eligible, !!cadeau);
        return null;
      })
      .catch(function () { /* panier illisible : on ne casse rien, on réessaiera */ })
      .then(function () { occupe = false; });
  }

  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(cycle, 250);
  }

  /* ---------------------------------------------------------------
     Rafraîchissement de l'affichage du thème

     C'est le seul endroit dépendant du thème. Renseigner SECTIONS avec les
     identifiants réels des sections panier ; sinon on retombe sur un repli
     honnête mais moins fin.
     --------------------------------------------------------------- */

  function rafraichir() {
    return json('/cart.js').then(function (cart) {
      pastille(cart.item_count);
      peindre(sousTotalEligible(cart), !!trouverCadeau(cart));

      if (SECTIONS.length) {
        return fetch('/?sections=' + SECTIONS.join(','))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            SECTIONS.forEach(function (id) {
              var html = sections[id];
              if (!html) { return; }
              var cible = document.getElementById('shopify-section-' + id) ||
                          document.querySelector('[id*="' + id + '"]');
              if (!cible) { return; }
              var frais = new DOMParser().parseFromString(html, 'text/html');
              var source = frais.getElementById('shopify-section-' + id) || frais.body.firstElementChild;
              if (source) { cible.innerHTML = source.innerHTML; }
            });
            monter();
          })
          .catch(function () {});
      }

      // Repli : sur la page panier, la seule façon fiable de dire la vérité est
      // de recharger. Ailleurs, la pastille suffit jusqu'à la prochaine navigation.
      if (window.location.pathname.indexOf('/cart') === 0) {
        window.location.reload();
      }
      document.dispatchEvent(new CustomEvent('sn:cadeau-maj', { detail: cart, bubbles: true }));
      return null;
    });
  }

  function pastille(n) {
    if (typeof n !== 'number') { return; }
    document.querySelectorAll('[data-cart-count],.cart-count-bubble [aria-hidden="true"]')
      .forEach(function (el) { el.textContent = n; });
  }

  /* ---------------------------------------------------------------
     La jauge

     Distance restante, pas pourcentage : le gradient d'objectif se lit en
     "combien il me manque", pas en "où j'en suis".
     --------------------------------------------------------------- */

  var CSS = [
    '.sn-cad{font-family:\'Work Sans\',sans-serif;margin:16px 0;}',
    '.sn-cad-track{position:relative;height:7px;background:#EDE7E0;border-radius:100px;overflow:hidden;}',
    '.sn-cad-fill{position:absolute;left:0;top:0;height:7px;border-radius:100px;background:#E9B0AD;width:0;transition:width .4s ease;}',
    '.sn-cad.is-ok .sn-cad-fill{background:#6B8F71;}',
    '.sn-cad-txt{display:flex;align-items:center;gap:8px;margin-top:10px;font-size:13px;line-height:1.4;color:#6B6866;}',
    '.sn-cad.is-ok .sn-cad-txt{color:#3B4A38;font-weight:600;}',
    '.sn-cad-ic{flex-shrink:0;width:18px;height:18px;border-radius:50%;background:#6B8F71;color:#FFF;display:none;align-items:center;justify-content:center;font-size:10px;font-weight:700;line-height:1;}',
    '.sn-cad.is-ok .sn-cad-ic{display:flex;}',
    '@media (prefers-reduced-motion:reduce){.sn-cad-fill{transition:none;}}'
  ].join('');

  function styler() {
    if (document.getElementById('sn-cad-css')) { return; }
    var s = document.createElement('style');
    s.id = 'sn-cad-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function monter() {
    styler();
    document.querySelectorAll(CIBLE).forEach(function (hote) {
      if (hote.querySelector('.sn-cad')) { return; }
      hote.innerHTML =
        '<div class="sn-cad">' +
          '<div class="sn-cad-track"><div class="sn-cad-fill"></div></div>' +
          '<div class="sn-cad-txt" role="status" aria-live="polite">' +
            '<span class="sn-cad-ic">\u2713</span><span class="sn-cad-lbl"></span>' +
          '</div>' +
        '</div>';
    });
    if (dernierEtat) { peindre(dernierEtat.eligible, dernierEtat.cadeau); }
  }

  function peindre(eligible, cadeau) {
    dernierEtat = { eligible: eligible, cadeau: cadeau };

    var noeuds = document.querySelectorAll(CIBLE + ' .sn-cad');
    if (!noeuds.length) { return; }

    var atteint = eligible >= SEUIL;
    var part = Math.min(100, Math.round((eligible / SEUIL) * 100));
    var reste = Math.max(0, SEUIL - eligible);
    var visible = offreActive() && eligible > 0;

    noeuds.forEach(function (n) {
      n.style.display = visible ? '' : 'none';
      n.classList.toggle('is-ok', atteint);
      n.querySelector('.sn-cad-fill').style.width = part + '%';
      n.querySelector('.sn-cad-lbl').textContent = atteint ? COPY.atteint : COPY.enRoute(eur(reste));
    });
  }

  /* ---------------------------------------------------------------
     Détection des changements de panier

     On intercepte fetch et XHR plutôt que d'écouter des événements de thème :
     tous les thèmes passent par /cart/*.js, aucun n'émet le même événement.
     --------------------------------------------------------------- */

  var ROUTES = /\/cart\/(add|change|update|clear)(\.js)?/;

  function urlDe(arg) {
    if (!arg) { return ''; }
    if (typeof arg === 'string') { return arg; }
    if (arg.url) { return arg.url; }
    return String(arg);
  }

  var fetchOrigine = window.fetch;
  window.fetch = function () {
    var url = urlDe(arguments[0]);
    var nous = interne;
    var retour = fetchOrigine.apply(this, arguments);
    if (!nous && ROUTES.test(url)) {
      retour.then(function () { planifier(); }).catch(function () {});
    }
    return retour;
  };

  var openOrigine = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__snUrl = url;
    return openOrigine.apply(this, arguments);
  };
  var sendOrigine = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (!interne && ROUTES.test(urlDe(self.__snUrl))) {
      self.addEventListener('load', function () { planifier(); });
    }
    return sendOrigine.apply(this, arguments);
  };

  document.addEventListener('sn:cart-updated', planifier);   // émis par les sélecteurs produit
  window.addEventListener('focus', planifier);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) { planifier(); }
  });

  /* ---------------------------------------------------------------
     Garde au checkout

     Le filet de sécurité. Si un retrait a échoué en silence, c'est ici qu'on
     évite de facturer 8 € un cadeau. Une seule vérification, puis on laisse
     passer quoi qu'il arrive : bloquer un checkout serait pire que le risque.
     --------------------------------------------------------------- */

  var verifie = false;

  document.addEventListener('click', function (e) {
    if (verifie) { return; }

    var cible = e.target.closest('[name="checkout"],a[href*="/checkout"],[data-sn-checkout]');
    if (!cible) { return; }

    e.preventDefault();
    verifie = true;

    var suivre = function () {
      if (cible.tagName === 'A') { window.location.href = cible.href; }
      else { cible.click(); }
    };

    cycle().then(suivre, suivre);
    setTimeout(suivre, 2500);   // si le réseau traîne, on n'immobilise personne
  }, true);

  /* --------------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { monter(); cycle(); });
  } else {
    monter();
    cycle();
  }
})();